import component from './ShimmerCard';

export default component;
